// API URL
// API base — .env.development (local) / .env.production (sunucu)
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

// Available columns configuration for CDR table
export const ALL_COLUMNS = [
  { id: "tarih", label: "Tarih", default: true },
  { id: "yon", label: "Yön", default: true },
  { id: "arayan_numara", label: "Arayan", default: true },
  { id: "aranan_numara", label: "Aranan", default: true },
  { id: "konusma_suresi", label: "Konuşma Süresi", default: true },
  { id: "did", label: "Departman", default: false },
  { id: "durum", label: "Durum", default: true },
  { id: "transkript", label: "Transkript", default: true },
  { id: "recording", label: "Ses Kaydı", default: true, requiresPermission: true }
];
